import type { PasswordConditions } from "~/types";

export function getPasswordStrength(passwordConditions: PasswordConditions) {
  if (!passwordConditions) return 0;
  return Object.values(passwordConditions).filter(Boolean).length;
}
